import axiosInstance from "./axios";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { setUser, setLogo } from "../Redux/userSlice";
import useFetchMedia from "./useGetMedia";

const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const dispatch = useDispatch();
  const { fetchMedia } = useFetchMedia();

  const url = "/manager/login";

  const login = async (userInput) => {
    setError(false);
    setLoading(true);
    try {
      const response = await axiosInstance.post(url, {
        email: userInput.email,
        password: userInput.password,
      });

      localStorage.setItem("Manager-token", response.data.token);
      sessionStorage.setItem("Manager-token", response.data.token);
      dispatch(setUser(response.data));
      setLoading(false);

      if (response.data?.school?.logoUrl) {
        fetchMedia(response.data?.school?.logoUrl).then((response) => {
          dispatch(setLogo(response));
        });
      }
    } catch (error) {
      setError(true);
      setLoading(false);
    }
  };

  return { login, loading, error };
};
export default useLogin;
